import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Currency = 'BRL' | 'USD';

interface CurrencyState {
  currency: Currency;
  setCurrency: (currency: Currency) => void;
}

const useCurrencyStore = create<CurrencyState>()(
  persist(
    (set) => ({
      currency: 'BRL',
      setCurrency: (currency) => set({ currency }),
    }),
    {
      name: 'mundpay_currency',
      // Ensure BRL is the default if no persisted value exists
      partialize: (state) => ({ currency: state.currency || 'BRL' }),
    }
  )
);

export default useCurrencyStore;
